/* unplugin-vue-components disabled */import { render } from "./ConvertQuizToExamLink.vue?vue&type=template&id=d8b2550c&scoped=true&ts=true"
import script from "./ConvertQuizToExamLink.vue?vue&type=script&lang=ts"
export * from "./ConvertQuizToExamLink.vue?vue&type=script&lang=ts"

import "./ConvertQuizToExamLink.vue?vue&type=style&index=0&id=d8b2550c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8b2550c"]])

export default __exports__